<template>
  <div class="appointment_main">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <input-select selectTitle="任务状态" :selectKey="'taskStatus'" selectWidth="180px" :selectData="taskStatusList" @search="search" style="margin-right: 10px;"/>
        <input-select selectTitle="计划类型" :selectKey="'planType'" selectWidth="180px" :selectData="planTypeList" @search="search"/>
      </div>
      <input-search placeholder="任务名称" @search="searchKey" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" @changeSelection="changeSelection" :hasOperation="false" :operationArr="operationArr" />

  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import InputSearch from '../../../components/Input/InputSearch'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/Inspection'
  import {errorHandler} from '../../../utils/errorHandler'
  import ButtonConfirmNext from '../../../components/Button/ButtonConfirmNext'
  import {nAlert, nSuccess} from '../../../utils/notice'
  import ButtonAdd from '../../../components/common/buttons/button-add'
  import InputSelect from "../../../components/Input/InputSelect";

  export default {
    components: {
      InputSelect,
      ButtonAdd,
      ButtonConfirmNext,
      TableMain,
      InputSearch,
      Breadcrumb},
    name: 'inspection-task-manage',
    data () {
      return {
        breadcrumb: [{
          value: '智慧巡检',
          name: 'inspection-device-type-manage'
        }, {
          value: '巡检任务'
        }],
        tableHead: [{
          prop: 'taskName',
          label: '任务名称',
          width: '300'
        }, {
          prop: 'teamName',
          label: '班组',
        }, {
          prop: 'planTypeText',
          label: '计划类型',
        }, {
          prop: 'executeTime',
          label: '执行时间',
          width: '180'
        }, {
          prop: 'planInspectCount',
          label: '计划巡检',
        }, {
          prop: 'completeInspectCount',
          label: '已经完成',
        }, {
          prop: 'undoneInspectCount',
          label: '尚未巡检',
        }, {
          prop: 'exceptionPointCount',
          label: '异常点位',
        }, {
          prop: 'taskStatusText',
          label: '任务状态',
        }],
        tableData: [],
        operationArr: ['modify', 'delete'],
        total: 0,
        pageSize: 10,
        pageNum: 1,
        timeValue: [],
        taskStatusList: [
          {
            key: '',
            label: '全部'
          }, {
            key: '1',
            label: '待巡检'
          }, {
            key: '2',
            label: '巡检中'
          }, {
            key: '3',
            label: '已完成'
          }, {
            key: '4',
            label: '旷巡'
          }, {
            key: '5',
            label: '漏巡'
          }
        ],
        planTypeList: [
          {
            key: '',
            label: '全部'
          }, {
            key: '1',
            label: '日计划'
          }, {
            key: '2',
            label: '周计划'
          }, {
            key: '3',
            label: '月计划'
          }, {
            key: '4',
            label: '季计划'
          }, {
            key: '5',
            label: '自定义'
          }
        ],
        requestData: {
          pageNum: 1,
          pageSize: 10,
          startTime: '',
          endTime: '',
          searchKey: '',
          planType: '',
          taskStatus: ''
        },

        selectionArr: []
      }
    },
    created () {
      this.getPage()
    },
    activated() {
      this.getPage()
    },
    methods: {
      toAddPage () {
        this.$router.push({
          name: 'inspection-plan-add'
        })
      },
      toModifyPage (code) {
        this.$router.push({
          path: '/inspection_plan_modify/' + code
        })
      },
      changeTimeValue () {
        this.pageNum = 1
        this.pageSize = 10
        this.getPage()
      },
      getPage () {
        let reqData = this.requestData
        reqData.pageNum = this.pageNum
        reqData.pageSize = this.pageSize
        this.$axios.post(api.getInspectTaskPage, reqData)
          .then(res => {
            let list = res.data.data.list
            list.map(v => {
              if (v.planType === '1') {
                v.planTypeText = '日计划'
              } else if (v.planType === '2') {
                v.planTypeText = '周计划'
              } else if (v.planType === '3') {
                v.planTypeText = '月计划'
              } else if (v.planType === '4') {
                v.planTypeText = '季计划'
              } else if (v.planType === '5') {
                v.planTypeText = '自定义'
              }
              if (v.taskStatus === '1') {
                v.taskStatusText = '待巡检'
              } else if (v.taskStatus === '2') {
                v.taskStatusText = '巡检中'
              } else if (v.taskStatus === '3') {
                v.taskStatusText = '已完成'
              } else if (v.taskStatus === '4') {
                v.taskStatusText = '旷巡'
              } else if (v.taskStatus === '5') {
                v.taskStatusText = '漏巡'
              }
            })
            this.total = res.data.data.total
            this.tableData = list
          })
          .catch(errorHandler('获取失败'))
      },
      search (v) {
        this.pageNum = 1
        this.requestData[v.key] = v.value
        this.getPage()
      },
      searchKey (v) {
        this.pageNum = 1
        this.requestData.searchKey = v
        this.getPage()
      },
      changePagination (data) {
        this.pageNum = data[0]
        this.pageSize = data[1]
        this.getPage()
      },

      changeSelection (codeArr) {
        this.selectionArr = codeArr
      },
    },
    watch: {}
  }
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>

<style lang="less">
  .appointment_main {
    .el-dialog .el-dialog__body .el-table .has-gutter th:first-child {
      /*width: 50%!important;*/
    }

    .right-slide-enter,
    .right-slide-leave-active {
      transform: translateX(100%);
    }

    .right-slide-leave-active,
    .right-slide-enter-active {
      transition: all 0.3s;
    }
    .window-left-box {
      position: fixed;
      right: 0;
      top: 0;
      bottom: 0;
      width: 60%;
      z-index: 10;
    }
    .window-left-box .move-enter-active, .window-left-box .move-leave-active {
      transition: all 2s linear;
      transform: translate3d(0, 0, 0);
    }
    .window-left-box .move-enter, .window-left-box .move-leave {
      transform: translate3d(100%, 0, 0);
    }
    .window-left-main {
      width: 100%;
      height: 100%;
      z-index: 30;
      background: #FFFFFF;
      padding: 5px 10px;
      overflow: auto;
    }

    .mask {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      opacity: .4;
      z-index: -1;
      background-color: #000000;
      transition: opacity .5s ease;
    }

    form {
      width: 450px;
      margin: 0 auto;
      text-align: left;
    }
    .form-line {
      margin: 25px 0;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .line-text{
      color: #48576a;
      font-size: 14px;
      margin-right: 10px;
      width: 100px;
      display: flex;
      justify-content: space-between;
    }
    .line-info {
      width: 220px;
    }
    .form-btn-box {
      width: 530px;
      padding: 0 124px;
      margin: 40px auto 0;
      display: flex;
      justify-content: space-between;
    }

    .person-management-drawer {
      .el-icon-back {
        margin: 20px 20px 10px;
        display: block;
        border: 0;
        font-size: 20px;
        background-color: #ffffff;
        cursor: pointer;
      }
      .el-icon-back:hover {
        color: #00a0e6;
      }
      .all-table-class .el-table td {
        padding: 10px 0;
      }
      form {
        position: relative;
        .drawerPersonImg {
          position: absolute;
          right: 0;
          top: 0;
          width: 120px;
        }
        .noDrawerPersonImg {
          position: absolute;
          right: 0;
          top: 0;
          width: 120px;
          height: 150px;
          line-height: 160px;
          border: 1px dashed #dcdfe6;
          text-align: center;
          color: #999999;
        }
      }
    }
    .drawerBtnBox {
      width: 360px;
      padding-right: 60px;
      margin: 40px auto 0;
      .btn-confirm {
        border: 0;
        color: #FFF;
        padding: 8px 16px;
        background-color: #00a0e6;
        border-radius: 4px;
        margin-right: 60px;
      }
      .btn-confirm:hover {
        color: #FFF;
        background-color: #06b3ff;
      }
      .reject-button {
        border: 0;
        background-color: #f25721;
        color: #FFFFFF;
        border-radius: 4px;
      }
      .reject-button:hover {
        background-color: #F96E3D;
      }
    }
  }

  .el-dialog__body {
    .el-table .cell{
      text-align: center;
    }
    .el-table th>.cell {
      color: #48576a;
      font-weight: bold;
    }
  }
  .el-dialog {
    .el-dialog .el-dialog__body .el-table__empty-block {
      margin: 0 auto;
    }
    .el-table__empty-text {
      width: auto;
    }
    .el-dialog__header {
      text-align: center
    }
    .el-dialog__body {
      .el-table th:first-child {
        width: auto!important;
      }
    }
  }
  .btn-box {
    .el-date-editor .el-range-separator {
      padding: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/Inspection/InspectionTask/InspectionTaskManage.vue